<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="添加人员">
      </el-page-header>
      <form class="form-horizontal" @submit.prevent="handleUserNew">
        <div class="panel-body">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="form-group">
                <label class="col-md-4 control-label">用户名</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ error: $v.user.name.$error }"
                    v-model="user.name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">电话号码</label>
                <div class="col-md-8">
                  <input
                    type=""
                    class="form-control"
                    :class="{ error: $v.user.phone_number.$error }"
                    v-model="user.phone_number"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">角色</label>
                <div class="col-md-8">
                  <select
                    id="multiselect"
                    data-placeholder="角色选择"
                    multiple
                    tabindex="4"
                    v-model="user.role_ids"
                  >
                    <option :value="item.id" v-for="item in roles">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <button class="btn btn-success btn-labeled">保存</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { roleList, getFunctionModules, userNew } from '@/service/getData'
import { required, maxLength } from 'vuelidate/lib/validators'

const rightPhoneNumber = (value) => /^1\d{10}$/gi.test(value)

export default {
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(30),
      },
      phone_number: {
        required,
        rightPhoneNumber,
      },
    },
  },
  data() {
    return {
      user: {
        name: '',
        phone_number: '',
        function_module_ids: [],
        role_ids: [],
      },
      modules: [],
      roles: [],
    }
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      $('#multiselect')
        .chosen({ width: '100%' })
        .change(function () {
          that.user.role_ids = $(this)
            .val()
            .map((item) => {
              return parseInt(item)
            })
        })
    })
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await getFunctionModules()
      let rolesRes = await roleList()
      if (res.status != 0) return false
      this.modules = res.data
      this.roles = rolesRes.data
      this.$nextTick(() => {
        $('#multiselect').chosen({ width: '100%' }).trigger('chosen:updated')
      })
    },

    async handleUserNew() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      let res = await userNew(this.user)
      if (res.status == 0) {
        this.$router.go(-1)
      }
    },
  },
}
</script>